module.exports = __webpack_public_path__ + "static/img/1679717076995.495ff5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/1679717076995.png
// module id = b5Ci
// module chunks = 1